import Reveal from "@/components/Reveal";
import Footer from "@/components/Footer";

function GoogleG() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" className="h-12 w-12 shrink-0 md:h-14 md:w-14">
      <path fill="#4285F4" d="M23.5 12.3c0-.9-.1-1.6-.2-2.3H12v4.5h6.5c-.3 1.5-1.1 2.8-2.4 3.6v3h3.9c2.3-2.1 3.5-5.2 3.5-8.8z" />
      <path fill="#34A853" d="M12 24c3.2 0 6-1.1 8-2.9l-3.9-3c-1.1.7-2.5 1.2-4.1 1.2-3.1 0-5.8-2.1-6.7-5H1.3v3.1C3.3 21.3 7.3 24 12 24z" />
      <path fill="#FBBC05" d="M5.3 14.3c-.2-.7-.4-1.5-.4-2.3s.1-1.6.4-2.3V6.6H1.3C.5 8.2 0 10 0 12s.5 3.8 1.3 5.4l4-3.1z" />
      <path fill="#EA4335" d="M12 4.7c1.8 0 3.3.6 4.6 1.8l3.4-3.4C18 1.2 15.2 0 12 0 7.3 0 3.3 2.7 1.3 6.6l4 3.1c.9-2.9 3.6-5 6.7-5z" />
    </svg>
  );
}

function Stars() {
  const Star = ({ className }) => (
    <svg viewBox="0 0 24 24" aria-hidden="true" className={className}>
      <path
        fill="currentColor"
        d="M12 2l2.9 6.26 6.85.78-5.08 4.65 1.37 6.74L12 17.77l-6.04 3.26 1.37-6.74L2.25 9.04l6.85-.78L12 2z"
      />
    </svg>
  );
  return (
    <div
      data-testid="ikm-stars"
      role="img"
      aria-label="Rating 4,7 dari 5 bintang"
      className="relative inline-flex"
    >
      <div className="flex gap-1 text-[#D8E2EC]">
        {[0, 1, 2, 3, 4].map((i) => (
          <Star key={i} className="h-6 w-6 md:h-7 md:w-7" />
        ))}
      </div>
      <div
        className="absolute inset-0 flex gap-1 overflow-hidden"
        style={{ width: "94%" }}
      >
        {[0, 1, 2, 3, 4].map((i) => (
          <Star key={i} className="h-6 w-6 shrink-0 text-[#FBBC05] md:h-7 md:w-7" />
        ))}
      </div>
    </div>
  );
}

export default function IndeksKepuasanMasyarakat() {
  return (
    <div className="min-h-screen bg-white text-[#0B2440] antialiased">
      <main className="px-6 pb-20 pt-28 md:px-12 md:pt-32">
        <Reveal>
          <p className="inline-flex items-center gap-2 text-[11px] font-bold uppercase tracking-[0.14em] text-[#1479BF]">
            <span
              aria-hidden="true"
              className="h-1.5 w-1.5 rounded-full bg-[#E8A33D]"
            />
            Data dan Laporan — Indeks Kepuasan Masyarakat
          </p>
          <h1
            data-testid="ikm-title"
            className="mt-6 font-display text-4xl font-semibold leading-[1.05] text-[#0B2440] md:text-6xl"
          >
            Indeks Kepuasan Masyarakat
          </h1>
          <div className="mt-6 h-1.5 w-20 rounded-full bg-[#E8A33D]" />
        </Reveal>

        <Reveal delay={0.05}>
          <div data-testid="ikm-tabs" className="mt-12 flex flex-wrap gap-2">
            <a
              data-testid="ikm-tab-ikm"
              href="https://lldikti7.kemdiktisaintek.go.id/kinerja/ikm"
              target="_blank"
              rel="noopener noreferrer"
              className="rounded-full border border-[#E3EBF3] bg-white px-5 py-2.5 text-xs font-bold tracking-[0.08em] text-slate-600 transition-colors duration-300 hover:bg-[#EFF6FC] hover:text-[#1479BF]"
            >
              INDEKS KEPUASAN MASYARAKAT
            </a>
            <span
              data-testid="ikm-tab-google"
              aria-current="page"
              className="rounded-full bg-[#1479BF] px-5 py-2.5 text-xs font-bold tracking-[0.08em] text-white"
            >
              RATING GOOGLE
            </span>
          </div>
        </Reveal>

        <Reveal delay={0.1}>
          <div
            data-testid="ikm-google-rating"
            className="mt-14 flex w-full max-w-md items-center gap-7 rounded-3xl border border-[#E3EBF3] bg-[#F3F7FB] p-8 shadow-[0_18px_44px_rgba(11,36,64,0.08)] md:p-10"
          >
            <GoogleG />
            <div>
              <p
                data-testid="ikm-rating-value"
                className="font-display text-5xl font-semibold leading-none text-[#0B2440] md:text-6xl"
              >
                4,7
              </p>
              <div className="mt-4">
                <Stars />
              </div>
              <p className="mt-4 text-[11px] font-bold uppercase tracking-[0.14em] text-slate-500">
                Rating Google
              </p>
            </div>
          </div>
        </Reveal>
      </main>
      <Footer />
    </div>
  );
}
